import React from "react";
import dndIcon from "./../../../assets/icons/dnd.svg";

function TableDndIcon() {
  return <img src={dndIcon} />;
}

export default TableDndIcon;
